// src/components/UploadJson.js
import React, { useState } from "react";
import { Button, CircularProgress, Typography, Box } from "@mui/material";
import { uploadFiles } from "../services/uploadService";

export default function UploadJson() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [selectedFiles, setSelectedFiles] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFiles(e.target.files); // Almacenar los archivos seleccionados
  };

  const handleUpload = async () => {
    if (!selectedFiles) {
      setStatus("Por favor, selecciona archivos JSON.");
      return;
    }

    setLoading(true);
    setStatus("Subiendo archivos JSON a Firebase...");

    try {
      await uploadFiles(selectedFiles); // Pasar archivos al servicio
      setStatus("Archivos subidos exitosamente a Firebase.");
    } catch (error) {
      console.error("Error al subir archivos JSON:", error);
      setStatus("Error al subir los archivos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box textAlign="center" p={3}>
      <Typography variant="h5">Subir Archivos JSON a Firebase</Typography>
      
      <Button variant="contained" component="label" style={{ marginTop: "20px" }}>
        Seleccionar Archivos JSON
        <input type="file" accept=".json" multiple hidden onChange={handleFileChange} />
      </Button>
      
      {selectedFiles && (
        <Typography style={{ marginTop: "10px" }}>
          {selectedFiles.length} archivos seleccionados
        </Typography>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={handleUpload}
        disabled={loading}
        style={{ marginTop: "20px" }}
      >
        {loading ? "Subiendo..." : "Subir JSON"}
      </Button>

      {loading && <CircularProgress style={{ marginTop: "10px" }} />}
      {status && <Typography style={{ marginTop: "20px" }}>{status}</Typography>}
    </Box>
  );
}
